import * as React from 'react'

import { Spinner } from '~ui/components/Loading/Spinner/Spinner'
import { SpeedloEe } from '~ui/components/media/Svg/components/SpeedloEe'
import { Svg } from '~ui/components/media/Svg/Svg'

type TSpinnerProps = PropsOf<typeof Spinner>

type TProps = NoChildren &
  TSpinnerProps & {
    eeColor?: PropsOf<typeof Svg>['color']
    eeContrast?: PropsOf<typeof Svg>['contrast']
    eeOpacity?: PropsOf<typeof Svg>['opacity']
  }

/**
 * loading spinner with ee logo in the middle
 */
export const SpeedloSpinner: React.FC<TProps> = ({
  eeColor,
  eeContrast,
  eeOpacity,
  ...spinnerProps
}) => {
  return (
    <Spinner {...spinnerProps}>
      <Svg component={SpeedloEe} color={eeColor} contrast={eeContrast} opacity={eeOpacity} />
    </Spinner>
  )
}
